<template>
    <a class="text-primary flex justify-self-stretch items-center mt-5 mb-2 cursor-pointer"
        @click.prevent="handleButtonClick()">
        <Icon name="ChevronBack" />
        Voltar
    </a>
</template>
<script>
import Icon from '@/Components/UI/Icons/Icon.vue'
import Notification from '@/Components/Notification.vue'
import NavLink from '@/Components/NavLink.vue'

export default {
    components: {
        Icon,
        Notification,
        NavLink
    },

    emits: ['onBack'],

    props: {
        data: Object,
    },

    methods: {
        handleButtonClick() {
            this.$emit('onBack')
        }
    }
}
</script>
<style scoped>
    .noscroll::-webkit-scrollbar {
        display: none; /* Hide scrollbar for Chrome, Safari and Opera */
    }
    .noscroll {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }
</style>
